export default {
  SET_HOTSITE_SLOT: (state, hotsiteSlot) => (state.hotsiteSlot = hotsiteSlot),
  SET_PRODUCTION_CONFIGURATION: (state, config) => (state.productionConfiguration = config),
  SET_PREVIEW_CONFIGURATION: (state, config) => (state.previewConfiguration = config),
  SET_CURRENT_CONFIGURATION: (state, config) => (state.currentConfiguration = config),
  SET_COLORS: (state, colors) => (state.colors = colors),
  UPDATE_COLORS: (state, colors) => {
    // Deep merge colors maintaining the structure
    state.colors = {
      ...state.colors,
      ...colors,
    }
  },
  SET_IMAGES: (state, images) => (state.images = images),
  UPDATE_IMAGES: (state, images) => (state.images = { ...state.images, ...images }),
  SET_POSITIONS: (state, positions) => (state.positions = positions),
  UPDATE_POSITIONS: (state, positions) => {
    state.positions = { ...state.positions, ...positions }
  },
  SET_OVERRIDES: (state, overrides) => {
    state.overrides = overrides
    if (!state.currentConfiguration.overrides) {
      state.currentConfiguration.overrides = {}
    }
    state.currentConfiguration.overrides = overrides
  },
  UPDATE_OVERRIDES: (state, overrides) => {
    state.overrides = { ...state.overrides, ...overrides }
    if (!state.currentConfiguration.overrides) {
      state.currentConfiguration.overrides = {}
    }
    state.currentConfiguration.overrides = {
      ...state.currentConfiguration.overrides,
      ...overrides,
    }
  },
  SET_FIELDS: (state, fields) => {
    state.fields = fields
    if (!state.currentConfiguration.settings) {
      state.currentConfiguration.settings = {}
    }
    state.currentConfiguration.settings.fields = fields
  },
  UPDATE_FIELDS: (state, fields) => {
    state.fields = { ...state.fields, ...fields }
    if (!state.currentConfiguration.settings) {
      state.currentConfiguration.settings = {}
    }
    if (!state.currentConfiguration.settings.fields) {
      state.currentConfiguration.settings.fields = {}
    }
    state.currentConfiguration.settings.fields = {
      ...state.currentConfiguration.settings.fields,
      ...fields,
    }
  },
  SET_LOADING: (state, loading) => (state.loading = loading),
  SET_ERROR: (state, error) => (state.error = error),
  SET_VALIDATION_ERRORS: (state, errors) => (state.validationErrors = errors),
  CLEAR_VALIDATION_ERRORS: (state) => {
    state.validationErrors = {
      tabs: {},
      fields: {},
    }
  },
}
